<template>
  <div class="step-breadcrumb">
    <ul :class="'skin-'+skin">
      <li v-for="(step,index) of detail" :key="index"
          :class="{active:stepIndex===index+1,
          enabled:index===0&&stepIndex!==1||index===1&&stepIndex===3
          }"
          @click="stepChange(index+1)">
        <span v-text="step"/>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    stepIndex: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      detail: [
        this.$t('Search'),
        this.$t('Select Room'),
        this.$t('Payment'),
        this.$t('Confirmation')
      ]
    };
  },
  methods: {
    stepChange(index) {
      if (index === 1) {
        this.$router.push({
          'name': 'Home',
          query: {
            'skin': this.skin
          },
        })
      } else if (index === 2 && this.stepIndex === 3) {
        let query = Object.assign({}, this.$route.query)
        delete query.submit
        this.$router.push({
          'name': 'SelectRoom',
          query
        })
      }
    }
  },
  computed:{
    skin() {
      return this.$store.state.gaData.skinCode
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.step-breadcrumb {
  ul {
    height: 94px;
    display: flex;
    justify-content: center;
    align-items: center;
    counter-reset: num;
    li {
      display: flex;
      align-items: center;
      font-weight: bold;

      &:before {
        content: counter(num);
        counter-increment: num;
        display: block;
        width: 35px;
        height: 35px;
        background: #707070;
        border-radius: 50%;
        text-align: center;
        line-height: 35px;
        color: white;
        font-size: 18px;
        margin-left: 20px;
      }

      &:after {
        content: "\00bb";
        font-size: 20px;
      }

      span {
        margin: 0 20px;
        font-size: 15px;
      }

      &:last-child {
        &:after {
          display: none;
        }
      }

      &.active {
        &:before {
          background: #2d6d71;
          color: white;
        }

        span {
          color: #2d6d71;
        }
      }

      &.enabled {
        cursor: pointer
      }
    }
    &.skin-pvm{
      li{
        &.active {
          &:before {
            background: #80642F;
          }

          span {
            color: #80642F;
          }
        }
      }
    }
    &.skin-tkl{
      li{
        &.active {
          &:before {
            background: #000000;
          }
          span {
            color: #000000;
          }
        }
      }
    }
    &.skin-gl{
      li{
        &:before {
          background: #1f1f1f ;
        }

        span {
            color: #1f1f1f;
        }

        &.active {
          &:before {
            background: #b7a68a ;
          }
          span {
            color: #b7a68a;
          }
        }
      }
    }
  }

  @media (max-width: 767px) {
    display: none;
  }
}
</style>
